import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Flex,
  Text,
  Icon,
  Button,
  Input,
  InputGroup,
  InputLeftAddon,
  SimpleGrid,
  Tabs,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  useDisclosure,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogBody,
  AlertDialogFooter,
  useColorModeValue,
} from "@chakra-ui/react";

import React, { useMemo, useEffect, useState } from "react";
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import { useHistory } from "react-router-dom";
import AuthService from "services/auth.services.js";
import ApiService from "services/api.js";
import UtilService from "services/util.service.js";
// Custom components
import Card from "components/card/Card";
import Menu from "components/menu/MainMenu";
import Pagination from "components/dataDispaly/Pagination";
import HeaderEndOfDayData from "./HeaderEndOfDayData";

// Assets
import { MdCheckCircle, MdCancel, MdOutlineError } from "react-icons/md";
export default function EndOfDayData(props) {
  // custom variable
  let DateFrom = UtilService.dateFrom;
  let DateTo = UtilService.dateTo;

  const history = useHistory();

  // Use state variable
  const { columnsData } = props;
  const [data, setData] = useState([]);
  const [dataPage, setDataPage] = useState([]);
  const [dataPageSize, setDataPageSize] = useState(5);
  const [loading, setLoading] = useState(true);
  const [inputDateFrom, setDateFrom] = useState(DateFrom);
  const [inputDateTo, setDateTo] = useState(DateTo);
  const [inputBranch, setInputBranch] = useState("");
  const [urlExcel, setUrlExcel] = useState("");

  // ref variable
  const skipPageResetRef = React.useRef();

  // use disclosure
  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = React.useRef();

  // memo variable
  const columns = useMemo(() => columnsData, [columnsData]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageCount: dataPage },
      manualPagination: true,
      pageCount: dataPage,
      autoResetPage: !skipPageResetRef.current,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );
 // console.log("count", pageCount);
 // console.log("count dp", dataPage);

  //Branch Data
  const options = ApiService.optionsBranch()

  useEffect(() => {
    setLoading(true);
    try {
      const fetchData = async () => {
        try {
          skipPageResetRef.current = true;
          const requestOptions = await ApiService.options();
          let response = await ApiService.client.get('/dataEOD/getAllDataEOD', {
            params: {
              page: pageIndex + 1,
              limit: dataPageSize,
              branch_ids: inputBranch === "" ? options?.map(data => data.id).join(',') : inputBranch,
              //branch_name: inputBranchName === "" ? "" : inputBranchName,
              from_order_date: inputDateFrom,
              to_order_date: inputDateTo
            }, ...requestOptions
          });
          // }, await ApiService.options());

         // console.log("total_halaman", response.data["total_halaman"]);
          setDataPage(response.data["total_halaman"]);
          setPageSize(dataPageSize);
          setData(response.data.data);
          skipPageResetRef.current = false;
        } catch (error) {
          if (error.response && error.response.status === 401) {
            try {
              await AuthService.logout();
              // console.log("Success Logout");
              history.push("/auth/sign-in");
              return;
            } catch (logoutError) {
              console.error("Logout error:", logoutError);
              history.push("/auth/sign-in");
              return;
            }
          }
          // console.log("error ni", error.response ? error.response.status : error);
        }
      };
      // setUrlExcel(ApiService.excel + `/dataEOD/exportAllDataEOD/${inputBranch === "" ? "all" : inputBranch}/${inputDateFrom}/${inputDateTo}`)
      let excelUrl =
        ApiService.excel +
        `/dataEOD/exportAllDataEOD?`+
        `branch_ids=${inputBranch === ""
          ? options?.map((data) => data.id).join(",")
          : inputBranch
        }&` +
        `from_order_date=${inputDateFrom}&` +
        `to_order_date=${inputDateTo}`;
      setUrlExcel(excelUrl);
      fetchData();
    } catch (error) {
      if (error.response.status === 401) {
        AuthService.logout();
        history.push("/auth/sign-in");
      }
      // console.log(error);
    }
  }, [
    pageIndex,
    dataPage,
    dataPageSize,
    pageSize,
    inputBranch,
    inputDateFrom,
    inputDateTo,
  ]);


  const textColor = useColorModeValue("secondaryGray.900", "white");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");

 // console.log("ini data lho", data);

  return (
    <Card
      direction={{ base: "column", sm: "row" }}
      w="100%"
      px="0px"
      overflowX={{ sm: "scroll", md: "scroll", lg: "scroll" }}
    >
      <Flex px="25px" justify="space-between" mb="20px" align="center">
        <Text
          color={textColor}
          fontSize="22px"
          fontWeight="700"
          lineHeight="100%"
        >
          End Of Days Data
        </Text>
        <Menu urlExcel={urlExcel} />
      </Flex>

      <HeaderEndOfDayData
        inputDateFrom={inputDateFrom}
        inputDateTo={inputDateTo}
        inputBranch={inputBranch}
        setDateFrom={setDateFrom}
        setDateTo={setDateTo}
        setInputBranch={setInputBranch} />

      <Table {...getTableProps()} variant="simple" color="gray.500" mb="24px">
        <Thead>
          {headerGroups.map((headerGroup, index) => (
            <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
              {headerGroup.headers.map((column, index) => (
                <Th
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  pe="10px"
                  key={index}
                  borderColor={borderColor}
                >
                  <Flex
                    justify="space-between"
                    align="center"
                    fontSize={{ sm: "10px", lg: "12px" }}
                    color="gray.400"
                  >
                    {column.render("Header")}
                  </Flex>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody {...getTableBodyProps()}>
          {page.map((row, index) => {
            prepareRow(row);
            return (
              <Tr {...row.getRowProps()} key={index}>
                {row.cells.map((cell, index) => {
                  let data = "";
                  if (cell.column.Header === "ORDER DATE") {
                    data = (
                      <Text color={textColor} fontSize="sm" fontWeight="700">
                        {cell.value}
                      </Text>
                    );
                  } else if (cell.column.Header === "BRANCH ID") {
                    data = (
                      <Text color={textColor} fontSize="sm" fontWeight="700">
                        {cell.value}
                      </Text>
                    );
                  } else if (cell.column.Header === "DAY BEGIN") {
                    data = (
                      <Text color={textColor} fontSize="sm" fontWeight="700">
                        {cell.value}
                      </Text>
                    );
                  } else if (cell.column.Header === "DAY END") {
                    data = (
                      <Text color={textColor} fontSize="sm" fontWeight="700">
                        {cell.value}
                      </Text>
                    );
                  } else if (cell.column.Header === "TOTAL SALES RAW") {
                    data = (
                      <Text color={textColor} fontSize="sm" fontWeight="700">
                        {cell.value}
                      </Text>
                    );
                  } else if (cell.column.Header === "COUNT BILL RAW") {
                    data = (
                      <Text color={textColor} fontSize="sm" fontWeight="700">
                        {cell.value}
                      </Text>
                    );
                  } else if (cell.column.Header === "TOTAL SALES OK") {
                    data = (
                      <Text color={textColor} fontSize="sm" fontWeight="700">
                        {cell.value}
                      </Text>
                    );
                  } else if (cell.column.Header === "COUNT BILL OK") {
                    data = (
                      <Text color={textColor} fontSize="sm" fontWeight="700">
                        {cell.value}
                      </Text>
                    );
                  } else if (cell.column.Header === "TOTAL CANCEL BILL") {
                    data = (
                      <Text color={textColor} fontSize="sm" fontWeight="700">
                        {cell.value}
                      </Text>
                    );
                  } else if (cell.column.Header === "COUNT CANCEL BILL") {
                    data = (
                      <Text color={textColor} fontSize="sm" fontWeight="700">
                        {cell.value}
                      </Text>
                    );
                  } else if (cell.column.Header === "TOTAL CANCEL ITEM") {
                    data = (
                      <Text color={textColor} fontSize="sm" fontWeight="700">
                        {cell.value}
                      </Text>
                    );
                  } else if (cell.column.Header === "COUNT CANCEL ITEM") {
                    data = (
                      <Text color={textColor} fontSize="sm" fontWeight="700">
                        {cell.value}
                      </Text>
                    );
                  } else if (cell.column.Header === "TOTAL SALES CXM") {
                    data = (
                      <Text color={textColor} fontSize="sm" fontWeight="700">
                        {cell.value}
                      </Text>
                    );
                  } else if (cell.column.Header === "COUNT BILL CXM") {
                    data = (
                      <Text color={textColor} fontSize="sm" fontWeight="700">
                        {cell.value}
                      </Text>
                    );
                  }
                  return (
                    <Td
                      {...cell.getCellProps()}
                      key={index}
                      fontSize={{ sm: "14px" }}
                      minW={{ sm: "150px", md: "200px", lg: "auto" }}
                      borderColor="transparent"
                    >
                      {data}
                    </Td>
                  );
                })}
              </Tr>
            );
          })}
        </Tbody>
      </Table>
      <Pagination canNextPage={canNextPage} nextPage={nextPage} canPreviousPage={canPreviousPage}
        previousPage={previousPage} pageIndex={pageIndex} pageOptions={pageOptions}
        gotoPage={gotoPage} pageSize={pageSize} setDataPageSize={setDataPageSize} pageCount={pageCount} />
    </Card>

  );
}
